import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import NoFlowchartViewer from 'processes/graph-builder-processes/flowchart-viz/NoFlowchartViewer';
import ProcessTaskLineageViewer from 'processes/graph-builder-processes/flowchart-viz/ProcessTaskLineageViewer';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import {GRAY_LIGHTER} from 'ui-library/Colors';

import ProcessTaskFlowchartTabState from './ProcessTaskFlowchartTabState';

export default class ProcessTaskFlowchartTabView extends BufferTabView<ProcessTaskFlowchartTabState> {
  override render(): this {
    const missingFlowchartMessage = this.model.get('missingFlowchartMessage');
    if (missingFlowchartMessage == null) {
      const props = {
        rootTaskId: this.model.get('rootTaskId'),
        executionFlowchartId: this.model.get('executionFlowchartId'),
        taskId: this.model.get('procedureMethodTaskId') ?? this.model.get('taskId'),
      };
      renderToDOM(
        <div className={classNames(css(styles.tabBackground), 'react-tab-container')}>
          <ProcessTaskLineageViewer {...props} />
        </div>,
        this.el
      );
    } else {
      renderToDOM(
        <div className={classNames(css(styles.tabBackground), 'react-tab-container')}>
          <NoFlowchartViewer message={missingFlowchartMessage} />
        </div>,
        this.el
      );
    }
    return this;
  }

  override remove(): Backbone.View<ProcessTaskFlowchartTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ProcessTaskFlowchartTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';

const styles = StyleSheet.create({
  tabBackground: {
    background: GRAY_LIGHTER,
    padding: 0,
    maxHeight: '100%',
    overflow: 'hidden',
  },
});
